import React, { useState, useEffect } from "react";
import ButtonTextIcon from "../../../components/ui/ButtonTextIcon";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { FaPlus } from "react-icons/fa6";
import RSModal from "../../../components/ui/RSModal";
import PushNotificationPopUP from "./AddTemplete";
import { FaEdit } from "react-icons/fa";
import ViewTemplatePopUp from "./TempleteDetails";
import { API_URL } from "../../../utilities/constants";
import Pagination from "../../../components/common/Pagination";
import FullPageLoader from "../../../components/ui/FullPageLoader";
import PageTitle from "../../../components/common/PageTitle";
import { useUI } from "../../../context/ui";
import ButtonTertiary from "../../../components/ui/ButtonTertiary";
import UpdateNotification from "./UpdateNotification";
import ConfirmationModal from "../../../components/common/ConfirmationModal";
import AddTemplete from "./AddTemplete";
import AppNotificationTemplates from "../Marketing/AppNotificationTemplates";
import { handleApiCall } from "../../../utilities/helpers";
const buildQueryParams = (params) =>
  Object.entries(params)
    .filter(([_, value]) => value !== "")
    .map(([key, value]) => `${key}=${value}`)
    .join("&");
const Notification = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const tab = searchParams.get("tab");
  const [loading, setLoading] = useState(false);
  const { setSegmentTitle, addToastMessage } = useUI();
  const [data, setData] = useState([]);
  const location = useLocation();
  const queryparams = new URLSearchParams(location.search);
  const pageNo = queryparams.get("pageNo") || 0;
  const pageSize = queryparams.get("pageSize") || 10;
  const list = location.state;
 
   const fetchTemplates = async () => {
      setLoading(true);
      try {
        const query = buildQueryParams({ pageNo, pageSize });
        const result = await handleApiCall(
          `${API_URL}/api/1.0.0/template?sortOrder=DESC&${query}`
        );
    
        if (result?.responseStatus) {
          setData(result.data);
        } else if (result?.responseCode !== 200) {
          setData([]);
          addToastMessage({
            status: false,
            message: result.responseDescription ||"Something went wrong. Please try again later.",
          });
        } else {
          addToastMessage({
            status: false,
            message: "Failed to fetch templates.",
          });
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false);
      }
   };
  useEffect(() => {
    fetchTemplates();
  }, [location]);

  useEffect(() => {
    if (!tab) {
      navigate(-1);
    }
    setSegmentTitle("Customers -> Notification");
  }, [tab, navigate]);

  const handleTabChange = (newTab) => {
    setSearchParams({ tab: newTab });
  };

  const handleCancel = () => {
    searchParams.delete("tab");
    setSearchParams(searchParams);
    navigate("/customers?pageNo=0&pageSize=10");
  };

  const handleDelete = async (id) => {
    try {
      const url = `${API_URL}/api/1.0.0/template/${id}`;
      const response = await fetch(url, {
        method: "DELETE",
        headers: {
          "X-JWT-Assertion": localStorage.getItem("token"),
        },
      });

      if (response.ok) {
        fetchTemplates();
        addToastMessage({
          status: true,
          message: "Template deleted successfully.",
        });
      } else {
        addToastMessage({
          status: false,
          message: "Failed to delete the template.",
        });
      }
    } catch (e) {
      console.error("Error deleting template", e);
      addToastMessage({
        status: false,
        message: "An error occurred while deleting the template.",
      });
    }
  };

  const sendPushNotification = async (templateId) => {
    setLoading(true);
    try {
      
      const payload = {
        triggerForAll: list.allChecked,
        templateId: templateId,
      };

      const metaInfo = {};
      if (
        list.filterType === 1 ||
        list.filterType === 2 ||
        list.filterType === 3
      ) {

        metaInfo.searchType = list.filterType;
        metaInfo.search = list.search;
      }
      if (list.filterType === 4) {
        metaInfo.searchType = list.filterType;
        metaInfo.minBalance = list.minBalance;
        metaInfo.maxBalance = list.maxBalance;
      }
      if (list.filterType === 5) {
        metaInfo.searchType = list.filterType;
        metaInfo.startDate = list.startDate;
        metaInfo.endDate = list.endDate;
      }
      if (list.filterType === 6) {
        metaInfo.searchType = list.filterType;
        metaInfo.statusID = list.statusID;
      }
      if (list.filterType) {
        payload.metaInfo = metaInfo;
      }
      if (payload.triggerForAll) {
        payload.excludedUserIds = list.excludedTxnIds;
      } else {
        payload.includedUserIds = list.includedTxnIds;
      }
      const response = await fetch(API_URL + `/api/1.0.0/notification/notify`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-JWT-Assertion": localStorage.getItem("token"),
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        const resp = await response.json();

        if (resp?.result?.responseCode === 200) {
          addToastMessage({
            status: true,
            message: "Push notification sent successfully.",
          });
          navigate("/customers?pageNo=0&pageSize=10");
          setLoading(false);
          return;
        }
      }

      const resp = await response.json();
      addToastMessage({
        status: false,
        message:
          resp?.responseDescription ||
          "Something  went wrong. Please try again later.",
      });

      setLoading(false);
    } catch (error) {
      addToastMessage({
        status: false,
        message: "Something went wrong. Please try again later.",
      });
      setLoading(false);
    }
  };
  return (
    <>
      <PageTitle title="Customers/Noification" />
      <FullPageLoader isActive={loading} />
      <div
        className="flex"
        style={{ minHeight: "80vh", flexDirection: "column" }}
      >
        {tab && (
          <>
            <div
              className="rs-tabs flex"
              style={{
                gap: "15px",
                margin: "10px 20px",
                justifyContent: "space-between",
              }}
            >
              <ul className="tab-selector">
                {/* <li
                className={tab === "email" ? "active" : ""}
                onClick={() => handleTabChange("email")}
                style={{ cursor: "pointer" }}
              >
                <h6>Email</h6>
              </li> */}
                <li
                  className={tab === "app" ? "active" : ""}
                  onClick={() => handleTabChange("app")}
                  style={{ cursor: "pointer" }}
                >
                  <h6>App-notification</h6>
                </li>
              </ul>
            </div>

            {tab === "app" && (
              <AppNotificationTemplates sendallow={true} />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default Notification;
